import React, { useCallback, useEffect, FunctionComponent} from "react";
import { Card, Row, Col, Collapse } from "antd";
import { StoreType } from "../../../redux/store";
import { connect } from "react-redux";
import moment from "moment";
import LoadingGraph from "../../../wrappers/LoadingGraph";
import PropTypes from "prop-types";
import {
  PartnersSendingAdsRecord,
  AverageAdsPerPartnerRecord,
  ProcessedOrigamiAdsByGroupRecord,
  StartedOrigamiAdsByPublicationRecord
} from "../../../redux/types/reportTypes";
import fetchBilledAdsWtd, {
  FetchBilledAdsWtd
} from "../../../redux/actions/reports/fetchAdsWtd";
import fetchBilledAdsLwtd, {
  FetchBilledAdsLwtd
} from "../../../redux/actions/reports/fetchBilledAdsLwtd";
import fetchBilledAdsMtd, {
   FetchBilledAdsMtd
} from "../../../redux/actions/reports/fetchBilledAdsMtd";
import fetchBilledAdsLmtd, {
  FetchBilledAdsLmtd
} from "../../../redux/actions/reports/fetchBilledAdsLmtd";
import fetchReceivedAdsWtd, {
  FetchReceivedAdsWtd
} from "../../../redux/actions/reports/fetchReceivedAdsWtd";
import fetchReceivedAdsLwtd, {
  FetchReceivedAdsLwtd
} from "../../../redux/actions/reports/fetchReceivedAdsLwtd";
import fetchReceivedAdsMtd, {
  FetchReceivedAdsMtd
} from "../../../redux/actions/reports/fetchReceivedAdsMtd";
import fetchReceivedAdsLmtd, {
  FetchReceivedAdsLmtd
} from "../../../redux/actions/reports/fetchReceivedAdsLmtd";
import fetchPartnersSendingAds, {
  FetchPartnersSendingAds
} from "../../../redux/actions/reports/fetchPartnersSendingAds";
import fetchAverageAdsPerPartner, {
  FetchAverageAdsPerPartner
} from "../../../redux/actions/reports/fetchAverageAdsPerPartner";
import fetchProcessedAdsByGroup, {
  FetchProcessedAdsByGroup
} from '../../../redux/actions/reports/fetchProcessedAdsByGroup'
import fetchStartedAdsByPublication, {
  FetchStartedAdsByPublication
} from '../../../redux/actions/reports/fetchStartedAdsByPublication'
import AdsTrackerStatistics from "../AdTrackerStatistics"
import PartnersSendingAds from '../PartnersSendingAdsGraph'
import AverageAdsPerPartners from '../AverageAdsPerPartnersGraph'
import ProcessedAdsByGroupTable from '../ProcessedAdsByGroupTable'
import StartedAdsByPublicationTable from '../StartedAdsByPublicationTable'

type RecordOptions = 
  | ProcessedOrigamiAdsByGroupRecord
  | StartedOrigamiAdsByPublicationRecord;
export const rowClassName = (record: RecordOptions): string => {
  let className = "";
  if (record.wtd_diff < 0) className += "down-wtd-diff";
  else if (record.wtd_diff > 0) className += "up-wtd-diff";
  if (record.wtd_perc_diff < 0) className += " down-wtd-perc-diff";
  else if (record.wtd_perc_diff > 0) className += " up-wtd-perc-diff";
  if (record.mtd_diff < 0) className += "down-mtd-diff";
  else if (record.mtd_diff > 0) className += "up-mtd-diff";
  if (record.mtd_perc_diff < 0) className += " down-mtd-perc-diff";
  else if (record.mtd_perc_diff > 0) className += " up-mtd-perc-diff";
  if (record.qtd_diff < 0) className += "down-qtd-diff";
  else if (record.qtd_diff > 0) className += "up-qtd-diff";
  if (record.qtd_perc_diff < 0) className += " down-qtd-perc-diff";
  else if (record.qtd_perc_diff > 0) className += " up-qtd-perc-diff";
  return className;
};

type LegacyAdsProps = {
  billedAdsWtd: number;
  billedAdsLwtd: number;
  billedAdsMtd: number;
  billedAdsLmtd: number;
  receivedAdsWtd: number;
  receivedAdsLwtd: number;
  receivedAdsMtd: number;
  receivedAdsLmtd: number;
  billedAdsWtdLoading: boolean;
  billedAdsLwtdLoading: boolean;
  billedAdsMtdLoading: boolean;
  billedAdsLmtdLoading: boolean;
  receivedAdsWtdLoading: boolean;
  receivedAdsLwtdLoading: boolean;
  receivedAdsMtdLoading: boolean;
  receivedAdsLmtdLoading: boolean;
  partnerSendingAdsLoading: boolean;
  avgAdsPerPartnerLoading: boolean;
  processedAdsByGroupLoading: boolean;
  startedAdsByPublicationLoading: boolean;
  fetchBilledAdsWtd: FetchBilledAdsWtd;
  fetchBilledAdsLwtd: FetchBilledAdsLwtd;
  fetchBilledAdsMtd: FetchBilledAdsMtd;
  fetchBilledAdsLmtd: FetchBilledAdsLmtd;
  fetchReceivedAdsWtd: FetchReceivedAdsWtd;
  fetchReceivedAdsLwtd: FetchReceivedAdsLwtd;
  fetchReceivedAdsMtd: FetchReceivedAdsMtd;
  fetchReceivedAdsLmtd: FetchReceivedAdsLmtd;
  fetchPartnersSendingAds: FetchPartnersSendingAds;
  fetchAverageAdsPerPartner: FetchAverageAdsPerPartner;
  fetchProcessedAdsByGroup: FetchProcessedAdsByGroup;
  fetchStartedAdsByPublication: FetchStartedAdsByPublication;
  partnerSendingAdsRecords: Array<PartnersSendingAdsRecord>;
  avgAdsPerPartnerRecords: Array<AverageAdsPerPartnerRecord>;
  processedAdsByGroupRecord: Array<ProcessedOrigamiAdsByGroupRecord>;
  startedAdsByPublicationRecord: Array<StartedOrigamiAdsByPublicationRecord>
};

const initialFilters = () => {
  const endDate = moment();
  const startDate = moment().add(-1, "month");
  return { startDate, endDate };
};

export const LegacyAds: FunctionComponent<LegacyAdsProps> = ({
  billedAdsWtdLoading,
  billedAdsWtd,
  billedAdsLwtdLoading,
  billedAdsLwtd,
  billedAdsMtdLoading,
  billedAdsMtd,
  billedAdsLmtdLoading,
  billedAdsLmtd,
  receivedAdsWtdLoading,
  receivedAdsWtd,
  receivedAdsLwtdLoading,
  receivedAdsLwtd,
  receivedAdsMtdLoading,
  receivedAdsMtd,
  receivedAdsLmtdLoading,
  receivedAdsLmtd,
  partnerSendingAdsLoading,
  partnerSendingAdsRecords,
  avgAdsPerPartnerLoading,
  avgAdsPerPartnerRecords,
  fetchBilledAdsWtd,
  fetchBilledAdsLwtd,
  fetchBilledAdsMtd,
  fetchBilledAdsLmtd,
  fetchReceivedAdsWtd,
  fetchReceivedAdsLwtd,
  fetchReceivedAdsMtd,
  fetchReceivedAdsLmtd,
  fetchPartnersSendingAds,
  fetchAverageAdsPerPartner,
  fetchProcessedAdsByGroup,
  fetchStartedAdsByPublication,
  processedAdsByGroupRecord,
  processedAdsByGroupLoading,
  startedAdsByPublicationLoading,
  startedAdsByPublicationRecord,
}: LegacyAdsProps) => {
  const setInitialState = useCallback(() => {
    const initial = initialFilters();
    fetchBilledAdsWtd({...initial, report: "billed_legacy_ads_wtd"});
    fetchBilledAdsLwtd({...initial, report: "billed_legacy_ads_lwtd"});
    fetchBilledAdsMtd({...initial, report: "billed_legacy_ads_mtd"});
    fetchBilledAdsLmtd({...initial, report: "billed_legacy_ads_lmtd"});
    fetchReceivedAdsWtd({...initial, report: "received_legacy_ads_wtd"});
    fetchReceivedAdsLwtd({...initial, report: "received_legacy_ads_lwtd"});
    fetchReceivedAdsMtd({...initial, report: "received_legacy_ads_mtd"});
    fetchReceivedAdsLmtd({...initial, report: "received_legacy_ads_lmtd"});
    fetchPartnersSendingAds({...initial, report: "partners_sending_legacy_ads"});
    fetchAverageAdsPerPartner({...initial, report: "average_legacy_ads_per_partner"});
    fetchProcessedAdsByGroup({...initial, report: "processed_legacy_ads_by_group"});
    fetchStartedAdsByPublication({...initial, report: "started_legacy_ads_by_publication"});
  }, [fetchBilledAdsWtd, fetchBilledAdsLwtd, fetchBilledAdsMtd, fetchBilledAdsLmtd, fetchReceivedAdsWtd, fetchReceivedAdsLwtd, fetchReceivedAdsMtd, fetchReceivedAdsLmtd, fetchPartnersSendingAds, fetchAverageAdsPerPartner, fetchProcessedAdsByGroup, fetchStartedAdsByPublication]);

  useEffect(() => {
    setInitialState();
  }, [setInitialState]);

  return(
    <Card title="Legacy ads">
      <Row>
        <Col span={12}>
          <Card title="Billed Ads">
            <AdsTrackerStatistics
              adsWtdTitle="ADS WTD"
              adsWtdLoading={billedAdsWtdLoading}
              adsWtdValue={billedAdsWtd}
              adsLwtdTitle="ADS LWTD"
              adsLwtdLoading={billedAdsLwtdLoading}
              adsLwtdValue={billedAdsLwtd}
              adsMtdTitle="ADS MTD"
              adsMtdLoading={billedAdsMtdLoading}
              adsMtdValue={billedAdsMtd}
              adsLmtdTitle="ADS LMTD"
              adsLmtdLoading={billedAdsLmtdLoading}
              adsLmtdValue={billedAdsLmtd}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Received Ads">
            <AdsTrackerStatistics
              adsWtdTitle="ADS WTD"
              adsWtdLoading={receivedAdsWtdLoading}
              adsWtdValue={receivedAdsWtd}
              adsLwtdTitle="ADS LWTD"
              adsLwtdLoading={receivedAdsLwtdLoading}
              adsLwtdValue={receivedAdsLwtd}
              adsMtdTitle="ADS MTD"
              adsMtdLoading={receivedAdsMtdLoading}
              adsMtdValue={receivedAdsMtd}
              adsLmtdTitle="ADS LMTD"
              adsLmtdLoading={receivedAdsLmtdLoading}
              adsLmtdValue={receivedAdsLmtd}
            />
          </Card>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <LoadingGraph
            title="Partners Sending Ads"
            loading={partnerSendingAdsLoading}
            records={partnerSendingAdsRecords}
            Component={PartnersSendingAds}
            Extra={() => null}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <LoadingGraph
            title="Average Ads Per Partner"
            loading={avgAdsPerPartnerLoading}
            records={avgAdsPerPartnerRecords}
            Component={AverageAdsPerPartners}
            Extra={() => null}
          />
        </Col>
      </Row>
      <div className="accordion-container">
        <Collapse defaultActiveKey={["1", "2", "3", "4"]}>
          <Collapse.Panel header="Processed Legacy Ads By Group" key="1" extra={null}>
            <ProcessedAdsByGroupTable records={processedAdsByGroupRecord} loading={processedAdsByGroupLoading} />
          </Collapse.Panel>
          <Collapse.Panel header="Started Legacy Ads By Publication" key="2" extra={null}>
            <StartedAdsByPublicationTable records={startedAdsByPublicationRecord} loading={startedAdsByPublicationLoading} />
          </Collapse.Panel>
        </Collapse>
      </div>
    </Card>
  )
};

const mapDispatchToProps = {
  fetchBilledAdsWtd,
  fetchBilledAdsLwtd,
  fetchBilledAdsMtd,
  fetchBilledAdsLmtd,
  fetchReceivedAdsWtd,
  fetchReceivedAdsLwtd,
  fetchReceivedAdsMtd,
  fetchReceivedAdsLmtd,
  fetchPartnersSendingAds,
  fetchAverageAdsPerPartner,
  fetchProcessedAdsByGroup,
  fetchStartedAdsByPublication,
};

const mapStateToProps = ({
  reports: {
    billed_legacy_ads_wtd: { loading: billedAdsWtdLoading, records: billedAdsWtdRecords },
    billed_legacy_ads_lwtd: { loading: billedAdsLwtdLoading, records: billedAdsLwtdRecords },
    billed_legacy_ads_mtd: { loading: billedAdsMtdLoading, records: billedAdsMtdRecords },
    billed_legacy_ads_lmtd: { loading: billedAdsLmtdLoading, records: billedAdsLmtdRecords },
    received_legacy_ads_wtd: { loading: receivedAdsWtdLoading, records: receivedAdsWtdRecords },
    received_legacy_ads_lwtd: { loading: receivedAdsLwtdLoading, records: receivedAdsLwtdRecords },
    received_legacy_ads_mtd: { loading: receivedAdsMtdLoading, records: receivedAdsMtdRecords },
    received_legacy_ads_lmtd: { loading: receivedAdsLmtdLoading, records: receivedAdsLmtdRecords },
    partners_sending_legacy_ads: { loading: partnerSendingAdsLoading, records: partnerSendingAdsRecords },
    average_legacy_ads_per_partner: { loading: avgAdsPerPartnerLoading, records: avgAdsPerPartnerRecords },
    processed_legacy_ads_by_group: { loading: processedAdsByGroupLoading, records: processedAdsByGroupRecord },
    started_legacy_ads_by_publication: { loading: startedAdsByPublicationLoading, records: startedAdsByPublicationRecord },
  },
}: StoreType) => ({
  billedAdsWtdLoading,
  billedAdsLwtdLoading,
  billedAdsMtdLoading,
  billedAdsLmtdLoading,
  receivedAdsWtdLoading,
  receivedAdsLwtdLoading,
  receivedAdsMtdLoading,
  receivedAdsLmtdLoading,
  partnerSendingAdsLoading,
  avgAdsPerPartnerLoading,
  startedAdsByPublicationLoading,
  billedAdsWtd: billedAdsWtdRecords[0]?.count,
  billedAdsLwtd: billedAdsLwtdRecords[0]?.count,
  billedAdsMtd: billedAdsMtdRecords[0]?.count,
  billedAdsLmtd: billedAdsLmtdRecords[0]?.count,
  receivedAdsWtd: receivedAdsWtdRecords[0]?.count,
  receivedAdsLwtd: receivedAdsLwtdRecords[0]?.count,
  receivedAdsMtd: receivedAdsMtdRecords[0]?.count,
  receivedAdsLmtd: receivedAdsLmtdRecords[0]?.count,
  partnerSendingAdsRecords,
  avgAdsPerPartnerRecords,
  processedAdsByGroupLoading,
  processedAdsByGroupRecord,
  startedAdsByPublicationRecord,
});

LegacyAds.propTypes = {
  fetchBilledAdsWtd: PropTypes.func.isRequired,
  fetchBilledAdsLwtd: PropTypes.func.isRequired,
  fetchBilledAdsMtd: PropTypes.func.isRequired,
  fetchBilledAdsLmtd: PropTypes.func.isRequired,
  fetchReceivedAdsWtd: PropTypes.func.isRequired,
  fetchReceivedAdsLwtd: PropTypes.func.isRequired,
  fetchReceivedAdsMtd: PropTypes.func.isRequired,
  fetchReceivedAdsLmtd: PropTypes.func.isRequired,
  fetchPartnersSendingAds: PropTypes.func.isRequired,
  partnerSendingAdsLoading: PropTypes.bool.isRequired,
  partnerSendingAdsRecords: PropTypes.array.isRequired,
  fetchAverageAdsPerPartner: PropTypes.func.isRequired,
  avgAdsPerPartnerLoading: PropTypes.bool.isRequired,
  avgAdsPerPartnerRecords: PropTypes.array.isRequired,
  processedAdsByGroupRecord: PropTypes.array.isRequired,
  processedAdsByGroupLoading: PropTypes.bool.isRequired,
  fetchProcessedAdsByGroup: PropTypes.func.isRequired,
  fetchStartedAdsByPublication: PropTypes.func.isRequired,
  startedAdsByPublicationLoading: PropTypes.bool.isRequired,
  startedAdsByPublicationRecord: PropTypes.array.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LegacyAds);
